import type { PerformanceEventConfig } from '../../types';

export const eventId = (config: PerformanceEventConfig): {
    'event:id': string;
} => {
	return {
		'event:id': config.key,
	};
};
